import { render, staticRenderFns } from "./UserFamilyChildrenAdd.vue?vue&type=template&id=720df36c&"
import script from "./UserFamilyChildrenAdd.vue?vue&type=script&lang=js&"
export * from "./UserFamilyChildrenAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports